module.exports = __webpack_public_path__ + "media/images/user_default-fa4d8b27aba641644783029d58030bd9.png";